<template>
  <div class="memberunit">
    <div class="memberunit-content w1200">
      <h2 class="clum">
        <i class="icon">会员单位</i>
        <span class="more">更多</span>
      </h2>
      <ul class="member-list">
        <p style="text-align: center;line-height: 514px;font-size: 18px;font-weight: bold;">数据中心搭建中</p>
        <!-- <li class="list-item scale">
          <div class="item-top">
            <img src="../../../../static/images/logo-small.png" alt="">
            <span>鼎尖伯乐运动中心</span>
          </div>
          <div class="score">
            <span class="left">排名:<i>1</i></span>
            <span class="right">积分成绩:<i>20000</i></span>
          </div>
        </li>
        <li class="list-item reset-border">
          <div class="item-top">
            <img src="../../../../static/images/logo-small.png" alt="">
            <span>鼎尖伯乐运动中心</span>
          </div>
          <div class="score">
            <span class="left">排名:<i>1</i></span>
            <span class="right">积分成绩:<i>20000</i></span>
          </div>
        </li>
        <li class="list-item">
          <div class="item-top">
            <img src="../../../../static/images/logo-small.png" alt="">
            <span>鼎尖伯乐运动中心</span>
          </div>
          <div class="score">
            <span class="left">排名:<i>1</i></span>
            <span class="right">积分成绩:<i>20000</i></span>
          </div>
        </li>
        <li class="list-item">
          <div class="item-top">
            <img src="../../../../static/images/logo-small.png" alt="">
            <span>鼎尖伯乐运动中心</span>
          </div>
          <div class="score">
            <span class="left">排名:<i>1</i></span>
            <span class="right">积分成绩:<i>20000</i></span>
          </div>
        </li>
        <li class="list-item">
          <div class="item-top">
            <img src="../../../../static/images/logo-small.png" alt="">
            <span>鼎尖伯乐运动中心</span>
          </div>
          <div class="score">
            <span class="left">排名:<i>1</i></span>
            <span class="right">积分成绩:<i>20000</i></span>
          </div>
        </li>
        <li class="list-item scale">
          <div class="item-top">
            <img src="../../../../static/images/logo-small.png" alt="">
            <span>鼎尖伯乐运动中心</span>
          </div>
          <div class="score">
            <span class="left">排名:<i>1</i></span>
            <span class="right">积分成绩:<i>20000</i></span>
          </div>
        </li>
        <li class="list-item">
          <div class="item-top">
            <img src="../../../../static/images/logo-small.png" alt="">
            <span>鼎尖伯乐运动中心</span>
          </div>
          <div class="score">
            <span class="left">排名:<i>1</i></span>
            <span class="right">积分成绩:<i>20000</i></span>
          </div>
        </li>
        <li class="list-item">
          <div class="item-top">
            <img src="../../../../static/images/logo-small.png" alt="">
            <span>鼎尖伯乐运动中心</span>
          </div>
          <div class="score">
            <span class="left">排名:<i>1</i></span>
            <span class="right">积分成绩:<i>20000</i></span>
          </div>
        </li>
        <li class="list-item">
          <div class="item-top">
            <img src="../../../../static/images/logo-small.png" alt="">
            <span>鼎尖伯乐运动中心</span>
          </div>
          <div class="score">
            <span class="left">排名:<i>1</i></span>
            <span class="right">积分成绩:<i>20000</i></span>
          </div>
        </li> -->
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'tabs',
  data () {
    return {

    }
  },
  methods: {
  },
  mounted () {

  },
  created () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .memberunit{
    width: 100%;
    background-color: #fff;
  }
  .memberunit-content{
    padding: 20px 0px 50px 0px;
    background: #fff;
  }
  .memberunit-content .clum{
    overflow:hidden;
    margin-bottom: 35px;
  }
  .memberunit-content .clum .icon{
    font-size: 24px;
    font-weight: bold;
    background-position: 0px center;
    background-repeat: no-repeat;
    background-size: 5px 24px;
    background-image: url(../../../../static/images/sign_05.png);
    padding-left: 14px;
    font-style: normal;
    float: left;
  }
  .memberunit-content .clum span{
    float: right;
    font-size:16px;
    color:#409EFF;
    line-height:30px;
    cursor:pointer;
  }

  .member-list{
    width: 100%;
    overflow: hidden;
    height: 514px;
  }
  .list-item{
    text-align: center;
    float: left;
    width: 222px;
    border-top:1px solid transparent;
    border-bottom:1px solid transparent;
    /*border-left:1px solid #e8e5e5;*/
    border-right:1px solid #e8e5e5;
    padding: 10px 0px;
    margin-bottom: 50px;
    margin-top: 42px;
  }
  .list-item:nth-child(5n){
    /* border-right: 0px; */
  }
  .reset-border{
    border-left:0px;
  }
  .list-item .item-top{
    text-align: center;
  }
  .list-item .item-top img{
    width:82px;
    height: 82px;
    display: block;
    margin: 0px auto;
  }
  .list-item .item-top span{
    font-size: 16px;
    color:#1a1919;
    line-height: 42px;
    display: block;
  }
  .list-item .score{
    font-size: 14px;
    padding: 0px 20px;
    overflow: hidden;
    width: 100%;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -o-box-sizing: border-box;
    -ms-box-sizing: border-box;
    box-sizing: border-box;
  }
  .list-item .score .left{
    float: left;
  }
  .list-item .score .right{
    float: right;
  }
  .list-item .score span{
    font-size: 14px;
    color:#060606;
  }
  .list-item .score i{
    font-style: normal;
    color:#fe0000;
  }
.tabs-item .icon{
  width: 46px;
  height: 46px;
  margin: 0px auto;
  display:block;
  background-position: 0px 0px;
  background-repeat: no-repeat;
  background-size: 46px 46px;
}
.tabs-item span{
  font-size:22px;
  color:#1e1e1e;
  margin-top: 20px;
  display: inline-block;
}
.tabs-item .icon1{
  background-image: url(../../../../static/images/zhengshu_icon.png);
}
.tabs-item .icon2{
  background-image: url(../../../../static/images/huiyuan_icon.png);
}
.tabs-item .icon3{
  background-image: url(../../../../static/images/xiehuijianjie_icon.png);
}

.scale{
    width: 304px;
    height:226px;
    border:2px solid #e8e5e5;
    margin-top: 0px;
    margin-bottom: 4px;
  }
  .scale .item-top img{
    width:104px;
    height: 104px;
  }
  .scale .item-top span{
    font-size: 18px;
    line-height: 44px;
    border-bottom: 1px solid #e6e6e6;
    width: 276px;
    margin: 0px auto 10px auto;
  }
  .scale .score{
    margin-top: 10px;
    padding: 0px 40px;
  }
  .scale .score span{
    font-size: 16px;
    padding: 21px 0px;
  }

</style>



// WEBPACK FOOTER //
// src/components/common/MemberUnit/MemberUnit.vue